import { useEffect, useState } from 'react';

type ImageNaturalSizeState = {
  src: string;
  width: number;
  height: number;
};

export function useImageNaturalSize(src: string) {
  const [size, setSize] = useState<ImageNaturalSizeState | null>(null);

  useEffect(() => {
    const image = new Image();
    image.onload = () => {
      setSize({
        src,
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    };
    image.src = src;
  }, [src]);

  if (size?.src !== src) {
    return {
      width: 0,
      height: 0,
    };
  }

  return {
    width: size.width,
    height: size.height,
  };
}
